import { Field, Int, ObjectType } from '@nestjs/graphql'
import { BaseThreadUserDto } from './baseThreadUser.dto'

@ObjectType()
export class AuthorThreadUserDto extends BaseThreadUserDto {
  @Field(t => Int, { nullable: true })
  arcTeamId?: number

  @Field(t => Int, { nullable: true })
  penNameId?: number

  @Field(t => Boolean)
  canAcceptMessages!: boolean

  @Field(t => Boolean)
  canSendMessages!: boolean
}
